import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext(null);

const getSystemDarkPreference = () => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
};

const applyTheme = (isDark) => {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
};

export const ThemeProvider = ({ children }) => {
  const [sysDark, setSysDark] = useState(getSystemDarkPreference);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;

    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (event) => setSysDark(event.matches);

    if (mq.addEventListener) {
      mq.addEventListener('change', handler);
      return () => mq.removeEventListener('change', handler);
    }

    mq.addListener(handler);
    return () => mq.removeListener(handler);
  }, []);

  useEffect(() => {
    applyTheme(sysDark);
  }, [sysDark]);

  return (
    <ThemeContext.Provider value={{ theme: 'system', isDark: sysDark }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within a ThemeProvider');
  return ctx;
};
